<template>
    <section id="projects" class="gradient" style="min-height: 400px; color:#FFFFFF">
        <mdb-container class="py-5">
            <mdb-row>
                <mdb-col md="6">
                    <h6 class="section-header-top">Projects</h6>
                    <h2>WHAT WE ARE WORKING ON</h2>
                    <hr class="hr-light"/>
                </mdb-col>
            </mdb-row>
        </mdb-container>
        <mdb-container>
            <div v-for="project in this.$parent.projects" :key="project.id">
                <mdb-row class="pb-5">
                    <mdb-col md="6">
                        <h6 class="section-header-top">{{project.subTitle}}</h6>
                        <h2><a :href="project.url" style="color: white!important;">{{project.title}}</a></h2>
                        <hr class="hr-light"/>
                        <p class="readable-text">
                            {{project.description}}
                        </p>
                        <mdb-btn v-if="project.url!=='javascript:void(0)'" outline="white" v-on:click.native="goto(project.url)">Learn More</mdb-btn>
                    </mdb-col>
                    <mdb-col md="6" class="pt-5">
                        <div class="container-fluid">
                            <div class="embed-responsive embed-responsive-16by9 z-depth-2 frame">
                                <iframe class="embed-responsive-item" :src="project.video"
                                        allowfullscreen></iframe>
                            </div>
                        </div>

                    </mdb-col>
                </mdb-row>
            </div>
        </mdb-container>


    </section>

</template>

<script>
    import {mdbContainer, mdbRow, mdbCol, mdbIcon, mdbBtn} from 'mdbvue';
    export default {
        name: "Projects",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbBtn
        },
        methods: {
            goto: function (url) {
                window.location.href = url;
            }
        }

    }
</script>

<style scoped>

    .container-fluid > iframe {
        width: 25px;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
    }

    .container-fluid > div {
        text-align: center;
        height: calc(100vh / 2);
        position: relative;
    }

    .container-fluid > div:nth-child(odd) {
        background: yellow;
    }
</style>